import { render, staticRenderFns } from "./MainToolbar.vue?vue&type=template&id=3315d05e"
import script from "./MainToolbar.vue?vue&type=script&lang=js"
export * from "./MainToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports